export class Client {
  clientCode;
  clientId;
  clientName;
  defaultQueryWindow;
  id;

  constructor(obj?: Client) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/admin/clients/clients.model.ts